import { render, staticRenderFns } from "./submitReport.vue?vue&type=template&id=40478bd6&scoped=true"
import script from "./submitReport.vue?vue&type=script&lang=js"
export * from "./submitReport.vue?vue&type=script&lang=js"
import style0 from "./submitReport.vue?vue&type=style&index=0&id=40478bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40478bd6",
  null
  
)

export default component.exports